import React from 'react';
import { Col, Row } from 'reactstrap';
import { isMobile } from "react-device-detect";


export default function QuickStartGuide({link, type, copy, linkCopy}) {

  return (
    <Row>
      <Col md={12} className={'text-left mb-1'}>

        <span style={{fontSize:'13px',marginBottom:'15px',color:'#858AA1'}}>
          {!isMobile && <span>{copy ? copy : `Have a question about ${type}? `}{' '}</span>}
           <a href={link} style={{fontWeight:500}} className="link-text" target="_blank">
             {linkCopy ? linkCopy : `Quick Start Guide`}&rarr;
          </a>
        </span>
      </Col>
    </Row>
  );
}
